<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import DashboardAppFrame from '../DashboardApp/Frame.vue';

const dashboardApps = useMapGetter('dashboardApps/getRecords');
const currentChat = useMapGetter('getSelectedChat');

const sidebarDashboardApps = computed(() =>
  dashboardApps.value.filter(app => app.position === 'sidebar')
);

const hasDashboardApps = computed(() => sidebarDashboardApps.value.length > 0);
</script>

<template>
  <div v-if="hasDashboardApps" class="dashboard-apps-sidebar">
    <div
      v-for="(dashboardApp, index) in sidebarDashboardApps"
      :key="dashboardApp.id"
      class="dashboard-app-item mb-4"
    >
      <div class="dashboard-app-header mb-2">
        <h6 class="text-sm font-medium text-n-slate-12 mb-0">
          {{ dashboardApp.title }}
        </h6>
      </div>
      <div class="dashboard-app-content h-64">
        <DashboardAppFrame
          :is-visible
          :config="dashboardApp.content"
          :position="index"
          :current-chat="currentChat"
        />
      </div>
    </div>
  </div>
  <div v-else class="text-center py-4 text-n-slate-11">
    <p class="text-sm">
      {{ $t('CONVERSATION_SIDEBAR.ACCORDION.DASHBOARD_APPS.NO_APPS') }}
    </p>
  </div>
</template>

<style scoped>
.dashboard-apps-sidebar {
  @apply w-full;
}

.dashboard-app-item {
  @apply border border-n-weak rounded-lg overflow-hidden;
}

.dashboard-app-header {
  @apply bg-n-slate-2 px-3 py-2 border-b border-n-weak;
}

.dashboard-app-content {
  @apply bg-n-background;
}

.dashboard-app-content :deep(iframe) {
  @apply w-full h-full border-0;
}
</style>
